import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { SearchService } from '../services/search.service';
import { Observable, map, catchError, of, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { PublicProfileStore } from '@app/stores/public-profile.store';
import { extractProfileIdentifier } from '@app/utils/public-profile.utils';

export const publicProfileGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const searchService = inject(SearchService);
  const publicProfileStore = inject(PublicProfileStore);
  const router = inject(Router);
  const http = inject(HttpClient);
  const handleProfile = (profile: any): Observable<boolean> => {
    if (!profile) {
      const reservedShortid = route.paramMap.get('shortId');
      return http.get<boolean>(`${environment.api}/ReservedShortId/check-is-reserved?shortId=${reservedShortid}`).pipe(
        map((response) => {
          if (response) {
            router.navigate(['/register'], { queryParams: { reservedShortid } });
          } else {
            router.navigate(['/error'], { queryParams: { reason: 'profile-not-found' } });
          }
          return false;
        }),
      );
    } else {
      publicProfileStore.setProfileInfo(profile);
    }
    return of(true);
  };

  const handleError = () => {
    router.navigate(['/error'], { queryParams: { reason: 'profile-not-found' } });
    return of(false);
  };

  const getProfileObservable = (params: any): Observable<any> => {
    const { shortId, domain, email } = params;

    if (shortId) return searchService.getPublicProfileByShortId(shortId);
    if (domain) return searchService.getPublicProfileByDomain(domain);
    if (email) return searchService.getPublicProfileByEmail(email);
    return of(null);
  };

  const params = extractProfileIdentifier(route.paramMap);

  return getProfileObservable(params).pipe(switchMap(handleProfile), catchError(handleError));
};
